// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__91u8q","normalXl":"styles_normalXl__WslE6","normalLg":"styles_normalLg__x6p6j","normalMd":"styles_normalMd__SHF4N","normalSm":"styles_normalSm__LyixX"};